import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { ForgotPasswordDto } from 'src/app/admin/models/account-model';
import { BaseComponent } from 'src/app/shared/base/base-component';
import { AuthService } from 'src/app/shared/providers/auth/auth-service.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent extends BaseComponent implements OnInit, OnDestroy {
  errorMessage: string;
  showPassword: boolean = false;
  captchaInput: string;
  captchaImageUrl: string;
  key: string;
  isMailSent: boolean = false;

  private _error = new Subject<string>();
  private emailRegex = "[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}";

  constructor(
    private fb: FormBuilder,
    private authService: AuthService) {
    super(true);
  }

  ngOnInit(): void {
    this._error.subscribe((message) => (this.errorMessage = message));

    this.createForm();
    this.refreshCaptcha();
  }

  ngOnDestroy(): void {
    this.subscription.forEach((sb) => sb.unsubscribe());
  }

  send() {
    this.submitted = true;
    if (this.formGroup.valid) {
      this._error.next('');
      const data = this.form_Group.controls;
      const obj = {
        email: data['email'].value,
        captchaKey: this.key,
        captchaInput: data["captchaInput"].value,
      } as ForgotPasswordDto;

      const sub = this.authService.forgotPassword(obj)
        .subscribe(() => {
          this.isMailSent = true;
          this.resetForm();
        }, error => {
          this.submitted = false;
          if (error.status === 403)
            this.translate.get(`ForgotPassword.${error.error.error.message}`).subscribe(msg => this._error.next(msg));
          else
            this.translate.get('ErrorCodes.GeneralError').subscribe(msg => this._error.next(msg));

          return this.logException(error);
        });

      this.subscription.push(sub);
    }
  }
  refreshCaptcha() {
    this.key = `captcha_${this.generateGuid()}`;
    this.authService.getCaptcha(this.key).subscribe((blob) => {
      this.captchaImageUrl = URL.createObjectURL(blob);
    });
  }

  private createForm() {
    this.formGroup = this.fb.group({
      email: [''],
      captchaInput: [''],
    });

    this.formGroup.statusChanges.subscribe(() => {/* console.log("test ", result)*/ });

    this.setCustomValidators();
  }
  private setCustomValidators() {
    const email: any | undefined = this.formGroup.get("email");
    const captchaInput: any | undefined = this.formGroup.get("captchaInput");

    email.setValidators([
      Validators.required,
      Validators.minLength(4),
      Validators.maxLength(60),
      Validators.pattern(this.emailRegex),
    ]);

    captchaInput.setValidators([
      Validators.required,
    ]);

    email.updateValueAndValidity();
  }
  private resetForm() {
    this.submitted = false;
    this.createForm();
  }
  private generateGuid(): string {
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
